export type BodyEventHandler<T> = (args: T) => void;

//todo: use local events and remove this file
export class OpenPoseBodyEventManager<T> {
  private eventHandlers: BodyEventHandler<T>[] = [];

  AddEventListener(handler: BodyEventHandler<T>): void {
    this.eventHandlers.push(handler);
  }

  RemoveEventListener(handler: BodyEventHandler<T>): void {
    this.eventHandlers = this.eventHandlers.filter(handler_current => handler_current !== handler);
  }

  TriggerEvent(args: T): void {
    this.eventHandlers.forEach(handler => handler(args));
  }
}
